export const DRAFT_CONFIRM_MESSAGE =
  'You are about to save this request as a draft. You can come back and edit it later.';

export const SUBMIT_CONFIRM_MESSAGE =
  'You are about to submit this request. Once submitted, it will be reviewed and approved by the relevant authority.';

export const SUBMIT_CONFIRM_WARNING_MESSAGE =
  'Warning: You cannot edit this later.';

export const PROCESS_SUBMIT_PROCESS_MESSAGE =
  'Processing request, please wait...';
